import DataSources from './DataSources'

export default DataSources
